<div class="start">
    <h1 class="head">IT Doc</h1>
    <h1 class="head">Ihre Zukunft ohne Zettelwirtschaft - digital, effizient, einfach!</h1>
    <h2 class="head2">Sie möchten mehr erfahren? - vereinbaren Sie einen Onlinetermin.</h2>
    <h3 class="head3">itdoc&#64;definitiv-ds.de / +49 251 927732-10</h3>
</div>